import {
  Filter,
  CssVariable,
  LengthEvaluator,
  Color,
} from '@wix/css-property-parser';

type CSSVariableValue = {
  type: 'variable';
  CSSvariable: string;
  defaultValue?: string;
};

type DropShadowParsedValue = {
  offsetX: string | null;
  offsetY: string | null;
  blurRadius: string | null;
  color: string | null;
};

type FilterParsedValue = {
  dropShadow: DropShadowParsedValue;
};

const parseFilterValue = (value: string): FilterParsedValue => {
  const filter = Filter.parse(value);

  const dropShadowValues: DropShadowParsedValue = {
    offsetX: null,
    offsetY: null,
    blurRadius: null,
    color: null,
  };

  const values: FilterParsedValue = {
    dropShadow: dropShadowValues,
  };

  if (!filter || ('type' in filter && filter.type === 'variable')) {
    return values;
  }

  // Handle dropShadow case
  if ('dropShadow' in filter && filter.dropShadow) {
    const dropShadow = filter.dropShadow;

    if ('offsetX' in dropShadow && dropShadow.offsetX) {
      dropShadowValues.offsetX = LengthEvaluator.toCSSValue(dropShadow.offsetX);
    }

    if ('offsetY' in dropShadow && dropShadow.offsetY) {
      dropShadowValues.offsetY = LengthEvaluator.toCSSValue(dropShadow.offsetY);
    }

    if ('blurRadius' in dropShadow && dropShadow.blurRadius) {
      dropShadowValues.blurRadius = LengthEvaluator.toCSSValue(
        dropShadow.blurRadius,
      );
    }

    if ('color' in dropShadow && dropShadow.color) {
      dropShadowValues.color = Color.toCSSValue(dropShadow.color);
    }
  }

  return values;
};

const filterParsedValueToString = (
  parsedValue: Record<string, DropShadowParsedValue>,
): string => {
  const dropShadow = parsedValue.dropShadow;
  const { offsetX, offsetY, blurRadius, color } = dropShadow;

  // If all values are null, return 'none'
  if (!offsetX && !offsetY && !blurRadius && !color) {
    return 'none';
  }

  const x = offsetX || '0px';
  const y = offsetY || '0px';

  const parts: string[] = [x, y];

  if (blurRadius) {
    parts.push(blurRadius);
  }

  if (color) {
    parts.push(color);
  }

  return `drop-shadow(${parts.join(' ')})`;
};

export { parseFilterValue, filterParsedValueToString };
